// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"ce208334","401":"26246cf0","453":"ace21015","526":"745e6bae","562":"b53864ab","649":"9c7b8e03","662":"aab4a315","672":"f4eda984","825":"deb068a3","835":"a285b407","855":"5c9970f3"}[chunkId] + ".chunk.js";
};